<script setup lang="ts">
const {locale, setLocale,} = useI18n()
const router = useRouter()
const route = useRoute()
let localePath = useLocalePath()

const langItems = [
  {
    value: 'en',
    label: 'English',
    icon: 'i-openmoji-flag-united-kingdom'
  },
  {
    value: 'hu',
    label: 'Magyar',
    icon: 'i-openmoji-flag-hungary'
  }
]

// @nuxt/ui v4: @update:model-value now emits the selected value (string) when value-key is set
async function onLanguageChange(newLocale: string) {
  await setLocale(newLocale)
  await navigateTo(localePath(route.fullPath))
}

</script>

<template>
  <div class="flex justify-between">
    <div class="lang">
      <USelectMenu
        v-model="locale"
        :items="langItems"
        value-key="value"
        @update:model-value="onLanguageChange"
        class="m-2"
      >
        <template #leading>
          <UIcon :name="langItems.find(item => item.value === locale)!.icon" />
        </template>
      </USelectMenu>
    </div>
  </div>
</template>

<style scoped>

</style>
